import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checked", "onChange", "label", "className", "id", "data-test-id"];
import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CheckboxContainer = styled.div.withConfig({
  displayName: "Checkbox__CheckboxContainer"
})({
  display: 'inline-block',
  verticalAlign: 'middle'
});
const HiddenCheckbox = styled.input.attrs({
  type: 'checkbox'
})({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '0.0625rem',
  margin: '-0.0625rem',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '0.0625rem'
});
const StyledCheckbox = styled.div.withConfig({
  displayName: "Checkbox__StyledCheckbox"
})(({
  checked,
  theme
}) => ({
  display: 'inline-block',
  width: '1.25rem',
  height: '1.25rem',
  flexShrink: 0,
  background: theme.color['fill-surface-default'],
  borderStyle: 'solid',
  borderWidth: theme.borderWidth[200],
  borderColor: checked ? theme.color['border-info-default'] : theme.color['border-core-default'],
  borderRadius: theme.borderRadius[100],
  transition: 'all 150ms',
  cursor: 'pointer'
}));
const CheckIcon = styled.svg.withConfig({
  displayName: "Checkbox__CheckIcon"
})(({
  theme
}) => ({
  marginTop: theme.space[25],
  fill: 'none',
  stroke: theme.color['fill-info-default'],
  strokeWidth: '0.25rem'
}));
const Label = styled.label.withConfig({
  displayName: "Checkbox__Label"
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.space[300],
  cursor: 'pointer',
  fontFamily: theme.typography['body-125'].fontFamily
}));
const Checkbox = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      checked,
      onChange,
      label,
      className,
      id,
      'data-test-id': dataTestId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CheckboxContainer, {
    className: className,
    children: /*#__PURE__*/_jsxs(Label, {
      children: [/*#__PURE__*/_jsx(HiddenCheckbox, Object.assign({
        ref: ref,
        checked: checked,
        onChange: onChange,
        id: id,
        "data-test-id": dataTestId
      }, props)), /*#__PURE__*/_jsx(StyledCheckbox, {
        checked: checked,
        children: checked && /*#__PURE__*/_jsx(CheckIcon, {
          viewBox: "0 2 24 24",
          children: /*#__PURE__*/_jsx("polyline", {
            points: "20 6 9 17 4 12"
          })
        })
      }), label && /*#__PURE__*/_jsx("span", {
        children: label
      })]
    })
  });
});
export default Checkbox;